import { useCallback } from 'react';
import reduxFreeFetcher from '@api/fetchers';

const useAPIHandler = () => {
  const apiCaller = useCallback(
    (endpoint) =>
      reduxFreeFetcher(endpoint, {
        useCamelCase: false
      }),
    []
  );
  return apiCaller;
};

export default useAPIHandler;
